var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"product_main div_border"},[_c('ProductMain')],1),_c('div',{staticClass:"Main_Filter div_border"},[_c('MainFilters')],1),_c('PageLoader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }